import { Input, type InputLabelProps } from "@mantine/core";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
} & InputLabelProps;

export function InputLable({ children, ...inputLabelProps }: Props) {
  const defaultOption: Omit<InputLabelProps, "children"> = {};
  const option = Object.assign({}, defaultOption, inputLabelProps);
  return <Input.Label {...option}>{children}</Input.Label>;
}
